import { render, staticRenderFns } from "./Ourbrand.vue?vue&type=template&id=57720d36&scoped=true&"
import script from "./Ourbrand.vue?vue&type=script&lang=js&"
export * from "./Ourbrand.vue?vue&type=script&lang=js&"
import style0 from "./Ourbrand.vue?vue&type=style&index=0&id=57720d36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57720d36",
  null
  
)

export default component.exports